module.exports = __webpack_public_path__ + "384132567a0c457046c0c97c7a009a19.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/background_sounds/storm.png
// module id = 3351
// module chunks = 0